type ConsoleMethod = keyof Console;
const proxyMethods: ConsoleMethod[] = [
	"log", //
	"error",
	"info",
	"warn",
	"debug",
	"trace",
];

export const oldConsole = console; // keep the old reference;

export type ConnectConsoleProxyHandler = (args: string) => void;

let handler: ConnectConsoleProxyHandler;

export const ConnectConsoleProxy: typeof window.console & {
	setConnectConsoleProxyHandler(handler: ConnectConsoleProxyHandler | string): void;
} = (() => {
	const creator = function (this: any) {
		proxyMethods.forEach((method) => {
			// --
			this[method] = function () {
				try {
					// eslint-disable-next-line prefer-rest-params
					// eslint-disable-next-line prefer-rest-params
					const funcArgs = [];
					if (arguments) {
						for (let i = 0; i < arguments.length; i++) {
							funcArgs.push(arguments[i]);
						}
					}
					const funcArgsSafe = createSafeArguments(funcArgs);

					const prefix = handler != null ? "cmaps: " : "cmaps:nh: ";
					(oldConsole[method] as Function).apply(oldConsole, [prefix, ...funcArgs]);

					handler?.(JSON.stringify([method, ...funcArgsSafe]));
				} catch (err) {
					oldConsole.error("Error while calling fake console", err);
				}
			};
		});
		this.setConnectConsoleProxyHandler = (handlerParam: ConnectConsoleProxyHandler | string) => {
			if (typeof handlerParam === "string") {
				const parts = (handlerParam as string).split(".") as string[];
				let pointer: any = window;
				for (const part of parts) {
					try {
						const next = pointer[part];
						if (next) {
							pointer = next;
						}
					} catch (err) {
						oldConsole.error(err);
					}
				}
				if (typeof pointer === "function") {
					handler = pointer as ConnectConsoleProxyHandler;
				}
			} else if (typeof handlerParam === "function") {
				handler = handlerParam as ConnectConsoleProxyHandler;
			}
		};
	};
	creator.prototype = console;
	// eslint-disable-next-line
	// @ts-ignore
	return new creator();
})();

const createSafeArguments = (funcArgs: any[]) => {
	return funcArgs.map((arg: any) => {
		try {
			if (arg instanceof Error) {
				return JSON.parse(
					JSON.stringify({
						type: "error",
						name: arg.name,
						message: arg.message,
						stack: arg.stack,
					})
				);
			}
			return JSON.parse(JSON.stringify(arg));
		} catch (err) {
			return arg?.toString();
		}
	});
};
